import { render, staticRenderFns } from "./EditarDoctor.vue?vue&type=template&id=12139675"
import script from "./EditarDoctor.vue?vue&type=script&lang=js"
export * from "./EditarDoctor.vue?vue&type=script&lang=js"
import style0 from "./EditarDoctor.vue?vue&type=style&index=0&id=12139675&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports